<topo-modal
  [isActive]="isActive$ | async"
  id="edit-profile-modal"
  [isCard]="true">
  <div class="modal-header">
    <div
      class="mx-4 my-4"
      fxLayout="row"
      fxLayoutAlign="space-between">
      <div>
        <h5>{{ 'MANAGEMENT.USERS.EDIT_PROFILE' | translate }}</h5>
      </div>
      <div>
        <div
          class="dialog-close"
          (click)="cancelClick()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-body">
    <form
      [formGroup]="form"
      class="is-relative">
      <div fxLayout="row">
        <div style="width: 350px">
          <section class="field">
            <label>{{ 'NOTIFICATION-PREFERENCES.DISPLAY_NAME' | translate }}</label>
            <div>
              <input
                class="input"
                type="text"
                placeholder="{{ 'NOTIFICATION-PREFERENCES.DISPLAY_NAME' | translate }}"
                formControlName="display_name" />
            </div>
          </section>

          <section class="field">
            <label>{{ 'NOTIFICATION-PREFERENCES.DISTANCE_UNITS' | translate }}</label>
            <div>
              <div class="select is-primary is-fullwidth">
                <select
                  class="small-select-font"
                  formControlName="distance_unit">
                  @for (ac of supportedUnits; track $index) {
                    <option
                      [ngValue]="ac">
                      {{ 'UNITS.DISTANCE.' + ac | translate }}
                    </option>
                  }
                </select>
              </div>
            </div>
          </section>

          <section class="field">
            <div
              fxLayout="row"
              fxLayoutAlign="space-between center">
              <label class="radio">{{ 'NOTIFICATION-PREFERENCES.USE-24H' | translate }}</label>
              <topo-switch formControlName="use_24h_time"></topo-switch>
            </div>
          </section>
        </div>
        <div class="ml-6">
          <div
            fxLayout="row"
            fxLayoutAlign="center center">
            <topo-avatar
              [name]="form.get('display_name')?.value || form.get('work_email')?.value"
              [imageUrl]="form.get('avatar_image')?.value"
              [size]="100"
            [fontSize]="30"></topo-avatar>
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="mt-3">
            <input
              #photo
              class="file-input"
              type="file"
              id="photo"
              (change)="fileChangeEvent($event)"
              accept="image/*" />
            <button
              type="button"
              class="button is-secondary is-small"
              (click)="changePhoto()">
              {{ 'NOTIFICATION-PREFERENCES.CHANGE-PHOTO' | translate }}
            </button>
          </div>
        </div>
        <div>
          <topo-modal [isActive]="isEditingPhoto">
            <div class="mx-4 my-4">
              <div
                fxLayout="row wrap"
                fxLayoutGap="20px">
                <div fxFlex>
                  <image-cropper
                    [imageFile]="imageFile"
                    [maintainAspectRatio]="true"
                    [resizeToWidth]="128"
                    [cropperMinWidth]="128"
                    [onlyScaleDown]="true"
                    [roundCropper]="true"
                    format="png"
                    output="base64"
                    (imageCropped)="imageCropped($event)"
                    (imageLoaded)="imageLoaded()"
                    (cropperReady)="cropperReady()"
                  (loadImageFailed)="loadImageFailed()"></image-cropper>
                </div>
                <div
                  fxFlex="128px"
                  fxLayout="column"
                  fxLayoutAlign="center center"
                  fxLayoutGap="20px">
                  <img
                    style="border-radius: 100%"
                    [src]="croppedImage" />
                  <img
                    style="border-radius: 100%; width: 60px; height: 60px"
                    [src]="croppedImage" />
                  <img
                    style="border-radius: 100%; width: 40px; height: 40px"
                    [src]="croppedImage" />
                </div>
                <div
                  fxFlex="100"
                  fxLayoutAlign="center center"
                  fxLayoutGap="10px"
                  class="md-margin-top">
                  <button
                    type="button"
                    class="button is-secondary"
                    (click)="closeImageCropper()">
                    {{ 'NOTIFICATION-PREFERENCES.BUTTON-CANCEL' | translate }}
                  </button>
                  <button
                    type="button"
                    class="button is-primary"
                    (click)="updatePhoto()">
                    {{ 'NOTIFICATION-PREFERENCES.BUTTON-UPDATE-PHOTO' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </topo-modal>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <section
      class="field buttons mt-4"
      fxLayout="row"
      fxLayoutAlign="end">
      <button
        type="button"
        class="button is-secondary mr-2"
        (click)="cancelClick()">
        {{ 'NOTIFICATION-PREFERENCES.BUTTON-CANCEL' | translate }}
      </button>
      <button
        type="button"
        class="button is-primary"
        (click)="doneClick()">
        {{ 'NOTIFICATION-PREFERENCES.BUTTON-DONE' | translate }}
      </button>
    </section>
  </div>
</topo-modal>
